
function initPDP() {

  let currentTempId = null;

  /* ==================================
     THUMBNAILS + VERTICAL SCROLL
  ================================== */
  const thumbsViewport = document.querySelector(".pdp-thumbs__viewport");
  const thumbsList     = document.querySelector(".pdp-thumbs__list");
  const thumbs         = document.querySelectorAll(".pdp-thumbs__list img");
  const arrowBottom    = document.querySelector(".pdp-thumbs__arrow--bottom");
  const arrowTop       = document.querySelector(".pdp-thumbs__arrow--top");

  let thumbIndex = 0;

  function updateThumbsUI() {
    if (!thumbsViewport || !thumbsList || !thumbs.length) return;

    const activeThumb = thumbs[thumbIndex];
    const scrollTop =
      activeThumb.offsetTop -
      thumbsViewport.offsetHeight / 2 +
      activeThumb.offsetHeight / 2;

    thumbsViewport.scrollTo({ top: scrollTop, behavior: "smooth" });

    arrowTop.style.display =
      thumbsViewport.scrollTop <= 0 ? "none" : "flex";

    arrowBottom.style.display =
      thumbsViewport.scrollTop + thumbsViewport.offsetHeight >=
      thumbsList.scrollHeight
        ? "none"
        : "flex";
  }

  arrowBottom?.addEventListener("click", () => {
    thumbIndex = Math.min(thumbIndex + 1, thumbs.length - 1);
    updateThumbsUI();
  });

  arrowTop?.addEventListener("click", () => {
    thumbIndex = Math.max(thumbIndex - 1, 0);
    updateThumbsUI();
  });

  /* ==================================
     MAIN IMAGE SLIDER
  ================================== */
  const slider       = document.querySelector(".pdp-main-image-slider");
  const sliderImages = document.querySelectorAll(".pdp-main-image-slider img");
  const leftArrow    = document.querySelector(".overlay-left-arrow");
  const rightArrow   = document.querySelector(".overlay-icon");

  let sliderIndex = 0;

  function updateSlider() {
    if (!slider || !sliderImages.length) return;
console.log("ddd", sliderImages)
    const width = slider.clientWidth;
    slider.style.transform = `translateX(-${sliderIndex * width}px)`;

    const activeImg = sliderImages[sliderIndex];
    currentTempId = activeImg?.dataset.tempid || null;

    thumbs.forEach((thumb, i) =>
      thumb.classList.toggle("active-thumb", i === sliderIndex)
    );

    thumbIndex = sliderIndex;
    updateThumbsUI();

    if (leftArrow)
      leftArrow.style.opacity = sliderIndex === 0 ? "0.3" : "1";
    if (rightArrow)
      rightArrow.style.opacity =
        sliderIndex === sliderImages.length - 1 ? "0.3" : "1";
  }

  leftArrow?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (sliderIndex > 0) sliderIndex--;
    updateSlider();
  });

  rightArrow?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (sliderIndex < sliderImages.length - 1) sliderIndex++;
    updateSlider();
  });

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener("click", () => {
      sliderIndex = index;
      updateSlider();
    });
  });

  /* ==================================
     RESTORE IMAGE FROM URL ?tempid=
  ================================== */
  const urlParams = new URLSearchParams(window.location.search);
  const urlTempId = urlParams.get("tempid");

  if (urlTempId && sliderImages.length) {
    sliderImages.forEach((img, i) => {
      if (img.dataset.tempid === urlTempId) sliderIndex = i;
    });
  }

  updateSlider();

  /* ==================================
     TABS
  ================================== */
  document.querySelectorAll(".tabs-section").forEach((section) => {
    const buttons = section.querySelectorAll(".tab-btn");
    const panels  = section.querySelectorAll(".tab-content");

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const tabId = btn.dataset.tab;

        buttons.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");

        panels.forEach((p) => p.classList.add("hidden"));
        const target = section.querySelector("#" + tabId);
        if (target) {
          target.classList.remove("hidden");
          bindAllCalculators();
        }
      });
    });
  });

  /* ==================================
     QTY SLIDER
     Reads locale from data-locale on the
     <input> (set in Liquid) so bubble text
     is always in the correct language.
     Reads base price from data-base-price on
     <strong> (set via Liquid divided_by:100)
     so French comma formatting never corrupts
     the number used in JS calculations.
  ================================== */
  // function initQtySlider() {
  //   const qtySlider = document.getElementById("qtySlider");
  //   if (!qtySlider || qtySlider._pdpBound) return;
  //   qtySlider._pdpBound = true;

  //   const bubble   = document.getElementById("sliderBubble");
  //   const qtyValue = document.getElementById("qtyValue");
  //   const qtyText  = document.getElementById("qtyText");
  //   const minusBtn = qtySlider.closest(".slider-area, .price-tab, .card")
  //                      ?.querySelector(".qty-btn--minus");
  //   const plusBtn  = qtySlider.closest(".slider-area, .price-tab, .card")
  //                      ?.querySelector(".qty-btn--plus");

  //   const min    = parseInt(qtySlider.min || 1,   10);
  //   const max    = parseInt(qtySlider.max || 100, 10);
  //   const locale = qtySlider.dataset.locale || "en";
  //   const isFr   = locale === "fr";
  //   const piecesLabel = isFr ? "Pièces" : "Pieces";

  //   // Base price from Liquid data attribute — always a clean decimal e.g. 69.99
  //   const priceStrong   = qtySlider.closest(".price-tab")?.querySelector(".unit-price strong");
  //   const baseUnitPrice = priceStrong
  //     ? parseFloat(priceStrong.dataset.basePrice || 0)
  //     : 0;

  //   function formatPrice(num) {
  //     // French: 69,99 €  |  English: € 69.99
  //     if (isFr) {
  //       return num.toFixed(2).replace(".", ",") + "\u00A0\u20AC";
  //     }
  //     return "\u20AC\u00A0" + num.toFixed(2);
  //   }

  //   function sync(val) {
  //     val = Math.min(max, Math.max(min, val));
  //     qtySlider.value = val;

  //     // Track fill
  //     const pct = ((val - min) / (max - min)) * 100;
  //     qtySlider.style.background =
  //       "linear-gradient(to right, #000 " + pct + "%, #ccc " + pct + "%)";

  //     // Bubble
  //     if (bubble) {
  //       bubble.textContent = val + " " + piecesLabel;
  //       bubble.style.left = "calc(" + pct + "% + " + (16 - pct * 0.32) + "px)";
  //       bubble.style.transform = "translateX(-50%)";
  //     }

  //     // Quantity displays
  //     if (qtyValue) qtyValue.textContent = val;
  //     if (qtyText)  qtyText.textContent  = val;

  //     // Price update
  //     if (priceStrong && baseUnitPrice) {
  //       let discount = 0;
  //       if      (val >= 100) discount = 0.45;
  //       else if (val >= 75)  discount = 0.40;
  //       else if (val >= 50)  discount = 0.35;
  //       else if (val >= 25)  discount = 0.25;
  //       else if (val >= 10)  discount = 0.15;
  //       else if (val >= 5)   discount = 0.10;

  //       priceStrong.textContent = formatPrice(baseUnitPrice * (1 - discount));

  //       const badge = qtySlider.closest(".price-tab")?.querySelector(".discount-badge");
  //       if (badge) {
  //         if (discount > 0) {
  //           badge.textContent = Math.round(discount * 100) + "% " +
  //             (isFr ? "REMISE QUANTITÉ" : "QUANTITY DISCOUNT");
  //         } else {
  //           badge.textContent = isFr ? "PAS DE REMISE" : "NO DISCOUNT";
  //         }
  //       }
  //     }
  //   }

  //   qtySlider.addEventListener("input",  function () { sync(parseInt(this.value, 10)); });
  //   qtySlider.addEventListener("change", function () { sync(parseInt(this.value, 10)); });
  //   minusBtn?.addEventListener("click",  function () { sync(parseInt(qtySlider.value, 10) - 1); });
  //   plusBtn?.addEventListener("click",   function () { sync(parseInt(qtySlider.value, 10) + 1); });

  //   sync(parseInt(qtySlider.value, 10));
  // }
function initQtySlider() {
  const qtySlider = document.getElementById("qtySlider");
  if (!qtySlider || qtySlider._pdpBound) return;
  qtySlider._pdpBound = true;

  const bubble   = document.getElementById("sliderBubble");
  const qtyValue = document.getElementById("qtyValue");
  const qtyText  = document.getElementById("qtyText");
  const minusBtn = qtySlider.closest(".slider-area, .price-tab, .card")
                     ?.querySelector(".qty-btn--minus");
  const plusBtn  = qtySlider.closest(".slider-area, .price-tab, .card")
                     ?.querySelector(".qty-btn--plus");

  const min    = parseInt(qtySlider.min || 1,   10);
  const max    = parseInt(qtySlider.max || 100, 10);
  const locale = qtySlider.dataset.locale || "en";
  const isFr   = locale !== "en";
  const piecesLabel = isFr ? "Pièces" : "Pieces";

  // Full lookup table: index 0 = qty 1 … index 98 = qty 99
  // Each entry: [totalPrice, discountPercent]
  const PRICE_TABLE = [
    [69.95,   0],  // 1
    [135.70,  3],  // 2
    [199.36,  5],  // 3
    [265.81,  5],  // 4
    [314.78, 10],  // 5
    [377.73, 10],  // 6
    [440.69, 10],  // 7
    [503.64, 10],  // 8
    [566.60, 10],  // 9
    [559.60, 20],  // 10
    [615.56, 20],  // 11
    [671.52, 20],  // 12
    [727.48, 20],  // 13
    [783.44, 20],  // 14
    [839.40, 20],  // 15
    [895.36, 20],  // 16
    [951.32, 20],  // 17
    [1007.28,20],  // 18
    [1063.24,20],  // 19
    [1049.25,25],  // 20
    [1101.71,25],  // 21
    [1154.18,25],  // 22
    [1206.64,25],  // 23
    [1259.10,25],  // 24
    [1311.56,25],  // 25
    [1364.03,25],  // 26
    [1416.49,25],  // 27
    [1468.95,25],  // 28
    [1521.41,25],  // 29
    [1573.88,25],  // 30
    [1626.34,25],  // 31
    [1678.80,25],  // 32
    [1731.26,25],  // 33
    [1783.73,25],  // 34
    [1713.78,30],  // 35
    [1762.74,30],  // 36
    [1811.71,30],  // 37
    [1860.67,30],  // 38
    [1909.64,30],  // 39
    [1958.60,30],  // 40
    [2007.57,30],  // 41
    [2056.53,30],  // 42
    [2105.50,30],  // 43
    [2154.46,30],  // 44
    [2203.43,30],  // 45
    [2252.39,30],  // 46
    [2301.36,30],  // 47
    [2350.32,30],  // 48
    [2399.29,30],  // 49
    [2273.38,35],  // 50
    [2318.84,35],  // 51
    [2364.31,35],  // 52
    [2409.78,35],  // 53
    [2455.25,35],  // 54
    [2500.71,35],  // 55
    [2546.18,35],  // 56
    [2591.65,35],  // 57
    [2637.12,35],  // 58
    [2682.58,35],  // 59
    [2728.05,35],  // 60
    [2773.52,35],  // 61
    [2818.99,35],  // 62
    [2864.45,35],  // 63
    [2909.92,35],  // 64
    [2955.39,35],  // 65
    [3000.86,35],  // 66
    [3046.32,35],  // 67
    [3091.79,35],  // 68
    [3137.26,35],  // 69
    [3182.73,35],  // 70
    [3228.19,35],  // 71
    [3273.66,35],  // 72
    [3319.13,35],  // 73
    [3364.60,35],  // 74
    [3410.06,35],  // 75
    [3455.53,35],  // 76
    [3501.00,35],  // 77
    [3546.47,35],  // 78
    [3591.93,35],  // 79
    [3637.40,35],  // 80
    [3682.87,35],  // 81
    [3728.34,35],  // 82
    [3773.80,35],  // 83
    [3819.27,35],  // 84
    [3864.74,35],  // 85
    [3910.21,35],  // 86
    [3955.67,35],  // 87
    [4001.14,35],  // 88
    [4046.61,35],  // 89
    [4092.08,35],  // 90
    [4137.54,35],  // 91
    [4183.01,35],  // 92
    [4228.48,35],  // 93
    [4273.95,35],  // 94
    [4319.41,35],  // 95
    [4364.88,35],  // 96
    [4410.35,35],  // 97
    [4455.82,35],  // 98
    [4501.28,35],  // 99
  ];

  function formatPrice(num) {
    if (isFr) {
      return num.toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + "\u00A0\u20AC";
    }
    return "\u20AC\u00A0" + num.toFixed(2);
  }

  function sync(val) {
    val = Math.min(max, Math.max(min, val));
    qtySlider.value = val;

    // Track fill
    const pct = ((val - min) / (max - min)) * 100;
    qtySlider.style.background =
      "linear-gradient(to right, #000 " + pct + "%, #ccc " + pct + "%)";

    // Bubble
    if (bubble) {
      bubble.textContent = val + " " + piecesLabel;
      bubble.style.left = "calc(" + pct + "% + " + (16 - pct * 0.32) + "px)";
      bubble.style.transform = "translateX(-50%)";
    }

    // Quantity displays
    if (qtyValue) qtyValue.textContent = val;
    if (qtyText)  qtyText.textContent  = val;

    // Price update
    const unitPriceEl = qtySlider.closest(".price-tab")?.querySelector("#unitPriceDisplay");
    const totalPriceEl = qtySlider.closest(".price-tab")?.querySelector("#totalPriceDisplay");
    const badge = qtySlider.closest(".price-tab")?.querySelector(".discount-badge");
    const discountLabel = isFr ? "REMISE QUANTITÉ" : "QUANTITY DISCOUNT";

  if (val >= 100) {
  const unit = 4501.28 / 99 * 100 / 100; // not needed — fixed unit price
  if (unitPriceEl)  unitPriceEl.textContent  = formatPrice(41.97);
  if (totalPriceEl) totalPriceEl.textContent = formatPrice(41.97 * 100);
  if (badge) badge.textContent = "40% " + discountLabel;
  return;
}

    const [total, discount] = PRICE_TABLE[val - 1];
    const unit = total / val;

    if (unitPriceEl)  unitPriceEl.textContent  = formatPrice(unit);
    if (totalPriceEl) totalPriceEl.textContent = formatPrice(total);
    if (badge) {
      badge.textContent = discount > 0
        ? discount + "% " + discountLabel
        : (isFr ? "PAS DE REMISE" : "NO DISCOUNT");
    }
  }

  qtySlider.addEventListener("input",  function () { sync(parseInt(this.value, 10)); });
  qtySlider.addEventListener("change", function () { sync(parseInt(this.value, 10)); });
  minusBtn?.addEventListener("click",  function () { sync(parseInt(qtySlider.value, 10) - 1); });
  plusBtn?.addEventListener("click",   function () { sync(parseInt(qtySlider.value, 10) + 1); });

  sync(parseInt(qtySlider.value, 10));
}
  initQtySlider();

  function bindAllCalculators() { initQtySlider(); }

  /* ==================================
     ACCORDION (MOBILE)
  ================================== */
  document.querySelectorAll(".accordion-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const item    = btn.closest(".accordion-item");
      const content = item?.querySelector(".accordion-content");
      if (!item || !content) return;

      const isOpen = item.classList.contains("open");

      item.closest(".mobile-tabs")
        ?.querySelectorAll(".accordion-item")
        .forEach((el) => {
          el.classList.remove("open");
          const c = el.querySelector(".accordion-content");
          if (c) c.style.maxHeight = null;
        });

      if (!isOpen) {
        item.classList.add("open");
        content.style.maxHeight = content.scrollHeight + "px";
        bindAllCalculators();
      }
    });
  });

  /* ==================================
     LIGHTBOX
  ================================== */
  const lightbox      = document.querySelector(".pdp-lightbox");
  const lightboxImg   = document.getElementById("lightbox-image");
  const lightboxClose = document.querySelector(".pdp-lightbox__close");
  const lightboxLeft  = document.querySelector(".pdp-lightbox__arrow--left");
  const lightboxRight = document.querySelector(".pdp-lightbox__arrow--right");

  let lightboxIndex = 0;

  function openLightbox(index) {
    if (!lightbox || !sliderImages.length) return;
    lightboxIndex = index;
    lightboxImg.src = sliderImages[lightboxIndex].src;
    lightbox.classList.add("active");
  }

  function closeLightbox() {
    lightbox?.classList.remove("active");
  }

  sliderImages.forEach((img, i) =>
    img.addEventListener("click", () => openLightbox(i))
  );

  lightboxClose?.addEventListener("click", closeLightbox);
  lightbox?.addEventListener("click", (e) => {
    if (e.target === lightbox) closeLightbox();
  });

  lightboxLeft?.addEventListener("click", () => {
    lightboxIndex = Math.max(0, lightboxIndex - 1);
    lightboxImg.src = sliderImages[lightboxIndex].src;
  });

  lightboxRight?.addEventListener("click", () => {
    lightboxIndex = Math.min(sliderImages.length - 1, lightboxIndex + 1);
    lightboxImg.src = sliderImages[lightboxIndex].src;
  });

  /* ==================================
     CUSTOMIZE BUTTON
  ================================== */

// NEW — uses CustomizerEmbed, no reload, waits for embed.js to finish loading
// document.addEventListener("click", function (e) {
//   const btn = e.target.closest(".customize-btn");
//   if (!btn) return;

//   e.preventDefault();
//   e.stopPropagation();

//   // Ignore clicks that bubbled up from slider/lightbox arrows
//   if (e.target.closest(".overlay-left-arrow, .overlay-icon, .pdp-lightbox__arrow")) return;

//   // Already working on it — ignore extra clicks
//   if (btn.classList.contains("loading")) return;

//   // --- Show loading state right away, before we even know CustomizerEmbed is ready ---
//   const originalText = btn.dataset.originalText ?? btn.textContent;
//   btn.dataset.originalText = originalText;
//   btn.classList.add("loading");
//   btn.disabled = true;
//   btn.textContent = btn.dataset.loadingText || "Loading...";

//   const resetBtn = () => {
//     btn.classList.remove("loading");
//     btn.disabled = false;
//     btn.textContent = btn.dataset.originalText;
//   };

//   const MAX_WAIT_MS = 6000;
//   const POLL_MS = 150;
//   const startedAt = Date.now();

//   function tryOpen() {
//     const ctx = window.CustomizerEmbed?.getProductContext?.();

//     if (ctx) {
//       try {
//         const result = window.CustomizerEmbed.openCustomizer({
//           vendorId:  ctx.vendorId,
//           productId: ctx.productId,
//           handle:    ctx.handle,
//           tempid:    currentTempId || sliderImages[0]?.dataset.tempid || undefined,
//         });

//         if (result && typeof result.then === "function") {
//           result.then(resetBtn).catch(resetBtn);
//         } else {
//           // Synchronous / instant modal open — reset shortly after
//           setTimeout(resetBtn, 600);
//         }
//       } catch (err) {
//         console.error("Failed to open customizer:", err);
//         resetBtn();
//       }
//       return;
//     }

//     // Not ready yet — keep polling until we time out
//     if (Date.now() - startedAt < MAX_WAIT_MS) {
//       setTimeout(tryOpen, POLL_MS);
//     } else {
//       console.warn("CustomizerEmbed never became ready or product not customizable");
//       resetBtn();
//     }
//   }

//   tryOpen();
// });
// }


/* ==================================
   CUSTOMIZE BUTTON
   Reliable first-click initialization
================================== */

let customizerReadyPromise = null;

/**
 * Wait for CustomizerEmbed to become available.
 * We start waiting when the PDP initializes instead of
 * waiting until the user clicks the button.
 */
function waitForCustomizer() {
  if (customizerReadyPromise) {
    return customizerReadyPromise;
  }

  customizerReadyPromise = new Promise((resolve, reject) => {
    const MAX_WAIT_MS = 15000;
    const POLL_MS = 100;
    const startedAt = Date.now();

    function check() {
      const embed = window.CustomizerEmbed;

      if (
        embed &&
        typeof embed.getProductContext === "function" &&
        typeof embed.openCustomizer === "function"
      ) {
        try {
          const context = embed.getProductContext();

          if (context) {
            resolve({
              embed,
              context,
            });
            return;
          }
        } catch (error) {
          console.warn("Customizer context not ready yet:", error);
        }
      }

      if (Date.now() - startedAt >= MAX_WAIT_MS) {
        reject(
          new Error("CustomizerEmbed did not become ready within 15 seconds")
        );
        return;
      }

      setTimeout(check, POLL_MS);
    }

    check();
  });

  return customizerReadyPromise;
}


/**
 * Start loading CustomizerEmbed immediately.
 *
 * This is important because the user should NOT have to
 * click the Customize button once just to initialize it.
 */
waitForCustomizer().catch((error) => {
  console.warn("Customizer initialization:", error);
});


/**
 * Get the currently selected product image tempid.
 */
function getCurrentTempId() {
  if (currentTempId) {
    return currentTempId;
  }

  return (
    sliderImages[sliderIndex]?.dataset.tempid ||
    sliderImages[0]?.dataset.tempid ||
    null
  );
}


/**
 * Open customizer.
 */
async function openProductCustomizer(btn) {
  if (!btn) return;

  // Prevent double-click while opening
  if (btn.dataset.customizerOpening === "true") {
    return;
  }

  btn.dataset.customizerOpening = "true";

  const originalText =
    btn.dataset.originalText ||
    btn.textContent.trim();

  btn.dataset.originalText = originalText;

  const loadingText =
    btn.dataset.loadingText ||
    (document.documentElement.lang === "fr" ? "Chargement..." : "Loading...");

  btn.classList.add("loading");
  btn.disabled = true;
  btn.setAttribute("aria-busy", "true");
  btn.textContent = loadingText;

  try {
    /*
     * Wait for CustomizerEmbed.
     *
     * Because this was already initialized when the PDP
     * loaded, this should normally resolve immediately.
     */
    const { embed, context } = await waitForCustomizer();

    if (!context) {
      throw new Error("Customizer product context is unavailable");
    }

    const tempid = getCurrentTempId();

    console.log("Opening customizer:", {
      vendorId: context.vendorId,
      productId: context.productId,
      handle: context.handle,
      tempid,
    });

    const result = embed.openCustomizer({
      vendorId: context.vendorId,
      productId: context.productId,
      handle: context.handle,
      tempid: tempid || undefined,
    });

    /*
     * If openCustomizer returns a Promise, wait for it.
     */
    if (result && typeof result.then === "function") {
      await result;
    }

  } catch (error) {
    console.error("Failed to open customizer:", error);

    /*
     * Reset the promise so another attempt can retry
     * initialization if the embed failed temporarily.
     */
    customizerReadyPromise = null;

  } finally {
    btn.classList.remove("loading");
    btn.disabled = false;
    btn.removeAttribute("aria-busy");
    btn.textContent = btn.dataset.originalText;

    btn.dataset.customizerOpening = "false";
  }
}


/**
 * Delegated click handler.
 *
 * Delegation is intentional because Shopify can re-render
 * parts of the product page dynamically.
 */
document.addEventListener("click", function (e) {
  const btn = e.target.closest("[data-customizer-open]");

  if (!btn) return;

  /*
   * Do not let the click trigger any parent handlers.
   */
  e.preventDefault();
  e.stopPropagation();

  /*
   * Ignore image/lightbox controls.
   */
  if (
    e.target.closest(
      ".overlay-left-arrow, .overlay-icon, .pdp-lightbox__arrow"
    )
  ) {
    return;
  }

  openProductCustomizer(btn);
});
}
/* ==================================
   INIT HANDLER
================================== */
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPDP);
} else {
  initPDP();
}